/* Souvenir timeline: plays its entrance once, when the section is a third into view (the line draws itself,
   the dots light up in turn, the cards rise in). The sequence itself is CSS, keyed on .is-visible. */
if (!customElements.get('souvenir-timeline')) {
  customElements.define(
    'souvenir-timeline',
    class SouvenirTimeline extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-visible');
            this.observer.disconnect();
          },
          { threshold: 0.3 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
